import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api, { executeAction } from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { t } from '../../../../i18n';

const cardsListApi = new Api('jobs/:id/cards_form_data');

function* loadData(data) {
  try {
    const { id } = data.payload;
    const result = yield call(sendRequest, cardsListApi.load, { id }, notifications.REQUEST_ERROR);

    if (result) {
      const { data: dataResult } = result;

      yield put(actions.loadDataSuccess({ data: dataResult }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* sendPaymentHistoryRequest({ payload }) {
  try {
    const { url, method, onSuccess } = payload;

    const result = yield call(sendRequest, executeAction, { url, method }, notifications.REQUEST_ERROR);

    if (result && result.messages) {
      onSuccess();
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: result.messages.join(' '),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.SEND_REQUEST, sendPaymentHistoryRequest)]);
}
